import React, {Component} from 'react';
import BackupDBFiles from './BackupDBFiles';
import lang from '../../Lang/lang.json';
import Icons from '../../../Containers/Icons';

class BackupDB extends Component {
  constructor(){
    super();
    this.dbInput= React.createRef();
    this.state = {
      dbfiles: false,
      bkpurl: false,
      delfile: ""
    }
  }
  componentWillMount() {
    this.readDBFiles();
  }
  closeDel = () => {
    this.props.funct('DBfileBk');
  }
  readDBFiles = () => {
    let bodycall = {
      type: "backup",
      post: {
        action: "read"
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      console.log(res);
      if (res.tkn === false) {
        this.props.logOut();
      } else {
        this.setState({dbfiles: res.files, bkpurl: res.url})
      }
    })
  }
  createBackupDB = () => {
    let bodycall = {
      type: "backup",
      post: {
        action: "create"
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      if (res) {
        console.log(res)
        this.props.msg('ok', 'e16');
        this.readDBFiles();
      } else {
        this.props.msg('error', 'e17');
      }
    })
  }
  checkTable = (file) => {
    if (file.includes("cards")){
      console.log("cards");
      return "cards";
    } else if (file.includes("tableros")) {
      return "tableros";
    } else if (file.includes("users")) {
      return "users";
    } else if (file.includes("visuals")) {
      return "visuals";
    }
  }
  restoreBackupDB = (file) => {
    let table = this.checkTable(file);
    console.log(table);
    let bodycall = {
      type: "backup",
      post: {
        action: "load",
        file: file,
        table: table
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      if (res) {
        console.log(res);
        this.props.msg('ok', 'e20');
        this.readDBFiles();
      } else {
        this.props.msg('error', 'e21');
      }
    })
  }
  selectDelete = (file) => {
    this.setState({delfile: file})
    this.props.funct('DBfileBk');
  }
  deleteDBFiles = () => {
    let bodycall = {
      type: "backup",
      post: {
        action: "delete",
        file: this.state.delfile
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodycall)
    }).then(res => res.json()).then(res => {
      this.props.msg('ok', 'e16');
      this.readDBFiles();
      this.closeDel();
      console.log(res);
    })
  }
  uploadDBFile = () => {
    this.dbInput.current.click();
  }
  selectFileToUpload = (event) => {
    let file = event.target.files[0];
    const data = new FormData();
    data.append("dbFile", file);
    console.log(file);
    data.append("tkn", this.props.tkn);
    data.append("screen", "addDBFile");
    fetch(`${this.props.url}api.php`, {
      method: "POST",
      body: data
    }).then((res) => (res.json()).then((res) => {
      if (res) {
        console.log(res);
        this.props.msg('ok', 'e18');
        this.readDBFiles();
      } else {
        this.props.msg('error', 'e19');
      }
    }));
  }
  render () {
    let {url, language} = this.props;
    let openMod;
    this.props.openMod
    ? openMod = "open"
    : openMod = "closed"
    return(
      <div id="backup_db">
        <div className="backup_files">
          <div className="tab_titles">
            <span className="filetitle">{lang.BackupDB.title[language]}</span>
            <span>{lang.BackupDB.download[language]}</span>
            <span>{lang.BackupDB.erase[language]}</span>
            <span>{lang.BackupDB.load[language]}</span>
          </div>
          <BackupDBFiles 
            type="db"
            language={language}
            openMod={this.selectDelete} 
            files={this.state.dbfiles} 
            url={url}
            restore={this.restoreBackupDB}/>
          <div className="backup_actions">
            <div 
              className="outline-butn gray"
              onClick={() => this.createBackupDB()}
            >
              {lang.BackupDB.create[language]}
            </div>
            <div className="outline-butn gray" onClick={() => this.uploadDBFile()}>
              {lang.BackupDB.upload[language]}
            </div>
            <input ref={this.dbInput} type="file" onChange={this.selectFileToUpload}/>
          </div>
        </div>
        <div className="backup_note">
          <div>
            <h2>{lang.BackupDB.note_title[language]}</h2>
            <p>{lang.BackupDB.note[language]}</p>
            <p>{lang.BackupDB.note2[language]}</p>
          </div>
        </div>
        <div className={`modal delete ${openMod}`}>
          <span className="formButton ok white" onClick={this.deleteDBFiles}>
            <Icons name="ok"/>
          </span>
          <span className="info">
            <h3>{lang.UsrCnf.delete[this.props.language]}</h3>
            <p>{lang.BackupDB.deleteinfo[this.props.language]}</p>
          </span>
          <span 
            className="formButton close white" 
            onClick={() => this.closeDel()}>
            <Icons name="close"/>
          </span>
        </div>
      </div>
    )
  }
}

export default BackupDB;


// WEBPACK FOOTER //
// ./src/Components/Admin/Backup/BackupDB.js